import { CloseOutlined } from '@mui/icons-material'
import { Button, Grid, IconButton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTable from '../../customTable'
import moment from 'moment'
import _ from 'lodash'
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import VisibilityIcon from '@mui/icons-material/Visibility';
const DayReports = ({setOpen  , dateData  , setActiveStep, setProductData}) => {
    const pageOption = [10, 25, 50, 100];
    const outletId = localStorage.getItem("outlet_id")
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const onClickEdit = (e) => {
        console.log(e.row)
        setProductData(e.row.salesData)
        setActiveStep("3")
    }
    const columns = [
        {
            field : 'sno',
            headerName : 'S.no',
            minWidth : 70,
            maxWidth : 100,
            headerAlign : 'center',
            align : 'center',
            sortable: false
          },
          {
            field: "docNo",
            headerName: "Doc No",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "docDate",
            headerName: "Doc Date",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "outletName",
            headerName: "Outlet Name",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "gst",
            headerName: "Gst",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "amount",
            headerName: "Amount",
            flex: 1,
            headerAlign: "center",
            align: "right",
            sortable: false,
            renderCell: (params) => (
              <strong>{params.value}</strong>
            ),
          },
          {
            field: "view",
            headerName: "View",
            disableExport: true ,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
            renderCell : (params) => {
                return(
                    <IconButton
                    size="small"
                    onClick={() => onClickEdit(params)}
                    >
                        <VisibilityIcon />
                    </IconButton>
                )
            }
          },
    ]
    const rows = _.map(dateData.data,(value,idx) =>({
        id: idx,
        sno: idx+1,
        docNo:value.docno,
        docDate:moment(value.docdate).format('YYYY-MM-DD'),
        outletName:value.outlet_type_name,
        gst:parseFloat(value.gst_amt).toFixed(0),
        amount: parseFloat(value.amount).toFixed(0),
        salesData : value.outlet_sales_lines
    }))
    const props = {
        columns : columns,
        rows : rows,
        page: page,
        setPage: setPage,
        rowsPerPage: rowsPerPage,
        setRowsPerPage: setRowsPerPage,
        pageCount: pageCount,
        pageOption: pageOption,
      }
      console.log(dateData)
      useEffect(()=>{
        if(dateData.data){
          setPageCount(dateData.data.length)
        }
      },[dateData])
  return (
    <Grid>
    <Grid sx={{display:"flex" , justifyContent:"space-between",padding:2,alignItems:"center"}}>
        <Button onClick={() => setActiveStep("1")} variant="contained">Back</Button>
        <Typography variant='h6'>Day reports</Typography>
        <IconButton onClick={() => {setOpen(false);setActiveStep("0") }}>
            <CloseOutlined />
        </IconButton>
    </Grid>
    <Grid>
        <CustomTable props={props}/>
    </Grid>
</Grid>
  )
}

export default DayReports